import { genderId } from '../constants/personal';

export const isUserFemale = (Gender) => {
  return !Gender ? false : Gender.toString() === genderId.FEMALE.toString();
};
